import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './fonts.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom"
import App from './SpinTheWheel/App';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
